import type { GroupDetail } from 'models';
import { Card, CollapsibleCard, DocumentLineIcon, RichTextRenderer } from 'ui';
import { Translation } from 'features/translations';

type P = {
  group: GroupDetail;
};

const GroupDetailDescription = ({ group }: P) => (
  <CollapsibleCard card={{ title: <Card.Title icon={<DocumentLineIcon />}>Description</Card.Title> }}>
    <RichTextRenderer data={group.htmlDescription} />
    <Translation id={group.id} type="group" />
  </CollapsibleCard>
);

export default GroupDetailDescription;
